module.exports = __webpack_public_path__ + "static/media/headerLogo.14348157.png";